export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10520.95426f18.jpg";